/* React base class */
import { Component } from "react"

/* Shared utilities (media url, fallbacks) */
import { utils } from "../../helpers"

/* Icon component */
import Icon from "../../components/Icon"

/* Review API: upload review photos */
import { photo as uploadReviewPhoto } from "../../api/Review"

/* Translation */
import { translate } from "../../translates"

/* Widget LeaveReview */
class LeaveReview extends Component {

    constructor(props) {
        super(props)
        /* State */
        this.state = {
            /* The master of the visit. A booking behind the review already names him, the card of
               the organization does not — there the client picks him out of the team */
            memberId: (props.master && props.master.id) || (props.initial && props.initial.masterId) || 0,
            rating: (props.initial && props.initial.rating) || 0,
            hover: 0,
            text: (props.initial && props.initial.text) || "",
            photos: (props.initial && props.initial.photos) || [],
            uploading: false,
            submitting: false
        }
    }

    /* Draw Specialists */
    _specialists = () => {

        /* Fields */
        const { specialists, master } = this.props

        /* A booking behind the review knows the master — nothing to choose */
        if (master && master.id) {
            return []
        }

        /* Check Specialists */
        if (specialists && Array.isArray(specialists)) {
            return specialists
        }

        return []
    }

    /* Ref to the hidden file input */
    _fileInput = null
    /* Guard against setState after unmount */
    _mounted = true

    componentWillUnmount = () => {
        this._mounted = false
    }

    /* Draw Pick */
    _pick = (event) => {
        const files = Array.from(event.target.files || [])
        event.target.value = ""
        if (!files.length) {
            return
        }
        /* Cap at 5 photos per review */
        const room = 5 - this.state.photos.length
        const queue = files.slice(0, room)
        this.setState({ uploading: true })
        Promise.all(queue.map((file) => uploadReviewPhoto(this.props.token, file))).then((responses) => {
            const uploaded = responses
                .filter((response) => response && response.status === 200)
                .map((response) => ({ id: response.data.id, url: response.data.url }))
            this.setState({ photos: [...this.state.photos, ...uploaded], uploading: false })
        })
    }

    /* Draw Remove Photo */
    _removePhoto = (id) => {
        this.setState({ photos: this.state.photos.filter((photo) => photo.id !== id) })
    }

    /* Draw Submit */
    _submit = () => {
        if (!this._canSubmit()) {
            return
        }
        this.setState({ submitting: true })
        const result = this.props.onSubmit({ memberId: this.state.memberId, rating: this.state.rating, text: this.state.text.trim(), photoIds: this.state.photos.map((photo) => photo.id) })
        if (result && typeof result.then === "function") {
            result.then(() => { if (this._mounted) { this.setState({ submitting: false }) } })
        }
        else if (this._mounted) {
            this.setState({ submitting: false })
        }
    }

    /* Draw Can Submit — a review without a master says nothing about the visit, so the team of
       the point standing in the form makes the choice a part of it */
    _canSubmit = () => {

        /* Fields */
        const { memberId, rating, text, uploading, submitting } = this.state

        /* Check Fields */
        if (!rating || !text.trim() || uploading || submitting) {
            return false
        }

        /* Check Master */
        if (this._specialists().length > 0 && !memberId) {
            return false
        }

        return true
    }

    render = () => {
        const labels = [translate("Ужасно"), translate("Плохо"), translate("Так себе"), translate("Хорошо"), translate("Отлично")]
        const active = this.state.hover || this.state.rating
        const specialists = this._specialists()
        const master = this.props.master
        const canSubmit = this._canSubmit()
        return (
            <div className="modal-backdrop" onClick={this.props.onClose}>
                <div className="modal modal--sm" onClick={(e) => e.stopPropagation()}>
                    <div className="modal__header">
                        <h3 className="modal__title">{this.props.editing ? translate("Изменить отзыв") : translate("Оставить отзыв")}</h3>
                        <button className="modal__close" onClick={this.props.onClose} aria-label={translate("Закрыть")}><Icon name="close" size={20} /></button>
                    </div>
                    <div className="modal__body" style={{ padding: 28 }}>
                        <div style={{ color: "var(--muted)", fontSize: 14, marginBottom: 20 }}>
                            {translate("Вы оцениваете")} <b style={{ color: "var(--ink)" }}>{this.props.name}</b>
                        </div>
                        {master && master.id && master.name && (
                            <div className="review-master-fixed">
                                <span className="review-master-fixed__label">{translate("Специалист")}</span>
                                <span className="review-master-fixed__name">{master.name}</span>
                            </div>
                        )}
                        {specialists.length > 0 && (
                            <div className="review-masters">
                                <div className="field__label review-masters__label">{translate("У кого вы были?")}</div>
                                <div className="review-masters__list">
                                    {specialists.map((specialist) => (
                                        <button
                                            key={`${specialist.id}`}
                                            type="button"
                                            className={`review-master ${parseInt(this.state.memberId) === parseInt(specialist.id) ? "is-active" : ""}`}
                                            onClick={() => this.setState({ memberId: specialist.id })}
                                        >
                                            <span className="review-master__avatar">
                                                {specialist.avatar ? <img src={utils.media(specialist.avatar)} alt="" onError={utils.onAvatarError} /> : <Icon name="user" size={18} />}
                                            </span>
                                            <span className="review-master__text">
                                                <span className="review-master__name">{specialist.name}</span>
                                                {specialist.profession && <span className="review-master__profession">{specialist.profession}</span>}
                                            </span>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        )}
                        <div className="field__label" style={{ marginBottom: 12 }}>{translate("Ваша оценка")}</div>
                        <div style={{ display: "inline-flex", gap: 6, marginBottom: 8 }}>
                            {[1, 2, 3, 4, 5].map((n) => (
                                <button key={`${n}`} onMouseEnter={() => this.setState({ hover: n })} onMouseLeave={() => this.setState({ hover: 0 })} onClick={() => this.setState({ rating: n })} style={{ color: n <= active ? "var(--star)" : "var(--muted-2)" }}>
                                    <Icon name="star" size={36} fill={n <= active ? "currentColor" : "none"} />
                                </button>
                            ))}
                        </div>
                        <div style={{ fontWeight: 700, marginBottom: 20, color: "var(--ink)", minHeight: 22 }}>{active > 0 ? labels[active - 1] : ""}</div>
                        <div className="field">
                            <label className="field__label">{translate("Расскажите о визите")}</label>
                            <textarea className="input" placeholder={translate("Что понравилось, что можно улучшить?")} value={this.state.text} onChange={(e) => this.setState({ text: e.target.value })} style={{ minHeight: 120 }} />
                        </div>
                        {this.state.photos.length > 0 && (
                            <div className="photo-edit" style={{ marginBottom: 14 }}>
                                {this.state.photos.map((photo) => (
                                    <div key={photo.id} className="photo-edit__item">
                                        <img src={photo.url} alt="" onError={utils.onImgError} />
                                        <button type="button" onClick={() => this._removePhoto(photo.id)} aria-label={translate("Удалить")}><Icon name="close" size={12} /></button>
                                    </div>
                                ))}
                            </div>
                        )}
                        <div className="photo-add">
                            <span className="photo-add__icon"><Icon name="image" size={26} /></span>
                            <div className="photo-add__text">
                                <div className="photo-add__title">{translate("Добавить фото")}</div>
                                <div className="photo-add__sub">{this.state.uploading ? translate("Загрузка…") : translate("Покажите результат — до 5 фото")}</div>
                            </div>
                            <button type="button" className="photo-add__btn" disabled={this.state.uploading || this.state.photos.length >= 5} onClick={() => this._fileInput && this._fileInput.click()}>{translate("Выбрать")}</button>
                            <input ref={(node) => { this._fileInput = node }} type="file" accept="image/*" multiple onChange={this._pick} style={{ display: "none" }} />
                        </div>
                        <button className="btn btn--block btn--lg" disabled={!canSubmit} style={{ opacity: canSubmit ? 1 : 0.5, marginTop: 24 }} onClick={this._submit}>
                            {this.state.submitting ? (this.props.editing ? translate("Сохранение…") : translate("Публикация…")) : (this.props.editing ? translate("Сохранить изменения") : translate("Опубликовать отзыв"))}
                        </button>
                        <div className="review-terms">{translate("Публикуя отзыв, вы соглашаетесь с")} <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">{translate("политикой конфиденциальности")}</a> Bookify.</div>
                    </div>
                </div>
            </div>
        )
    }
}

/* Export */
export default LeaveReview
